<template>
  <div class="inner-graph-content">
    <Spinner :isLoading="isLoading" />
    <template  v-if="videos != null && videos.data.length !=0">
      <div class="graph-area">
        <ul class="g-movie-area clearfix"
            v-for="(listVideo, index) in videoChunk" :key="index"
            :class="[ index % 2 === 0 ? 'mb20' : 'mb20']"
            v-lazy-container="{ selector: '.video-item' }"
        >
          <li v-for="(video, idx) in listVideo" :key="idx" @click="showVideo(video)" oncontextmenu="return false;" class="video-item">
            <a href="javascript:;">
              <div class="movie-thumb" :id="`${index}-${idx}`">
                <video-player
                  v-if="video.thumbnail_url == null"
                  :id="`video-${index}-${idx}`"
                  class="video-player-box"
                  style="text-align:center; object-fit: cover;"
                  width="100%"
                  height="400"
                  oncontextmenu="return false;"
                  :options="{...renderVideo(video), controls: false}">
                </video-player>
                <img v-else :src="video.thumbnail_url" width="100%" style="text-align:center; object-fit: cover;" height="400" :id="`video-${index}-${idx}`"/>
                <div class="movie-icon"></div>
              </div>
              <p> {{ convertToJPTime(video.create_date) }}</p>
            </a>
          </li>
        </ul>
      </div>
    
      <div class="pager-area pb-3">
        <PaginationByAPI :currentPage='currentPage' :totalPages='videos.last_page' v-on:changePage="changePage"/>
      </div>
    </template>

    <b-modal id="video-list-modal" centered :hide-header="true" :hide-footer="true" class="modal-content">
      <div class="modal-inner">
        <div class="close-icon modal-close" @click="closeModalListVideo()"></div>
        <div class="modal-movie-area">
          <b-carousel
            id="carousel-video"
            v-model="slide"
            :interval="0"
            :controls="videosShow.length > 1 ? true : false"
            background="#ffff"
            no-wrap
            style="text-shadow: 1px 1px 2px #333;"
            @sliding-start="onSlideStart"
            @sliding-end="onSlideEnd"
          >
            <b-carousel-slide v-for="(video, id) in videosShow" :key="id">
              <div><p class="movie-date-txt"> {{ convertToJPTime(video.create_date) }}</p></div>
              <video-player class="video-player-box"
                ref="videoPlayerSlider"
                oncontextmenu="return false;"
                @play="onPlayVideoSlider(id)"
                :options="renderVideo(video)">
              </video-player>
              <div class="movie-icon" :ref="'movie-icon'+id" @click="onPlayVideoSlider(id)"></div>
            </b-carousel-slide>
          </b-carousel>
        </div>
      </div>
    </b-modal>
  </div>
</template>

<script>
  import Spinner from '@/js/components/Spinner'
  import moment from 'moment'
  moment.suppressDeprecationWarnings = true
  import { videoPlayer } from 'vue-video-player'
  import 'video.js/dist/video-js.css'
  import 'vue-video-player/src/custom-theme.css'
  import { BModal, VBModal, BButton, BCarousel, BCarouselSlide} from 'bootstrap-vue'
  import ErrorDialog from '@/js/components/Common/ErrorDialog'
  import PaginationByAPI from '@/js/components/Common/PaginationByAPI'
  import { mapState } from 'vuex'

  export default {
    directives: { BModal, VBModal, BButton, BCarousel, BCarouselSlide },
    components: {
      BModal,
      BButton,
      Spinner,
      videoPlayer, 
      BCarousel, 
      BCarouselSlide,
      PaginationByAPI,
      ErrorDialog
    },
    props: {
      activePage: {
        type: String,
      }
    },
    data () {
      return {
        isLoading: true,
        videosShow: [],
        slide: 0,
        sliding: null,
        currentPage: 1,
        isDataLoaded: false,
      }
    },
    watch: {
      async activePage() {
        if(this.activePage === 'video' && !this.isDataLoaded) {
          await this.getVideoList(1)
          const video = document.getElementsByTagName('video')
          video.controls = false
          this.hideVideoControl()
          this.isDataLoaded = true
          this.isLoading = false
        }
      }
    },
    computed: {
      ...mapState({
        videos: state => state.patient.videoInOnePage,
        errorMsg: state => state.patient.errorMsg,
        otpAccessToken: state => state.otp.otpAccessToken
      }),
      videoChunk() {
        const videos = this.videos.data.filter((video) => video.video_access_url)
        if (videos) {
          return _.chunk(videos, 3)
        }
        return []
      },
      playerOptions() {
        return {
          sources: [{src: this.video.video_access_url }],
          width: '100%',
          height: '400'
        }
      },
      player() {
        return this.$refs.videoPlayer.player
      }
    },
    methods: {
      convertToJPTime(time) {
        const [year, month, dateTime] = time.split('-')
        const [date, times] = dateTime.split(' ')
        const [hour, minute, second] = times.split(':')
        const data = this.$t('year_month_day_hour_minute', {year: year, month: month, date: date, hour: hour, minute: minute})
        return data
      },
      showVideo(video) {
        this.videosShow = [video]
        this.$bvModal.show('video-list-modal')
      },
      renderVideo(video) {
        return {
          sources: [{src: video.video_access_url }],
          width: '100%',
          height: '400'
        }
      },
      showListVideo() {
        this.$bvModal.show('video-list-modal')
      },
      closeModalListVideo() {
        this.isPlaying = false
        this.$bvModal.hide('video-list-modal')
      },
      onPlayVideoSlider(index) {
        $(this.$refs['movie-icon' + index]).hide();
        let videosPlayer = this.$refs.videoPlayerSlider
        for (let i = 0; i < videosPlayer.length; i++) {
          if(i === index){
            videosPlayer[i].player.play()
          }
        }
        const event = {
          event: this.$t('video'),
          event_category: this.$t('video'),
          event_label: this.$t('reproduction')
        }
        this.eventTracking(event)
      },
      togglePlay() {
        if (this.isPlaying) this.player.pause()
        else this.player.play()
        this.isPlaying = !this.isPlaying
      },
      hideVideoControl() {
        const videoItems = document.querySelectorAll('.movie-thumb video')
        for (let i = 0; i < videoItems.length; i += 1) {
          videoItems[i].removeAttribute("controls")
          videoItems[i].load()
        }
      },
      onSlideStart(slide) {
        this.sliding = true
      },
      onSlideEnd(slide) {
        this.sliding = false
        let maxSlide = this.videosShow.length;
        let currentSlide = this.slide + 1;
        let btnPrev = document.querySelectorAll(".carousel-control-prev")[0]
        let btnNext = document.querySelectorAll(".carousel-control-next")[0]
        if(currentSlide === maxSlide){
          btnNext.style.display = "none"
          btnPrev.style.display = 'block'
        }
        else if(currentSlide === 1){
          btnPrev.style.display = "none"
          btnNext.style.display = "block"
        }
        else {
          btnNext.style.display = 'block'
          btnPrev.style.display = 'block'
        }
      },
      async getVideoList(page) {
        if(!this.$route.params.childId){
        let params = {
            one_time_access_key: this.otpAccessToken,
            page: page
          }
          await this.$store.dispatch("patient/getVideos", { params: params })
        } 
        else {
          let params = {
            childId: this.$route.params.childId,
            page: page
          }
          await this.$store.dispatch("patient/getVideosByChildId", { params: params })
        }
      },
      async changePage(page) {
        if(page != this.currentPage) {
          this.isLoading = true
          await this.getVideoList(page)
          this.currentPage = this.videos.current_page
          this.isLoading = false
        }
      },
    }
  }
</script>

<style>
  .video-js {
    width: 100%;
  }
  .vjs-big-play-button {
    display: none !important;
  }
  .video-js.vjs-ended .vjs-big-play-button {
      display: none !important;
  }
  .carousel-item {
    background: white !important;
  }
  .carousel-control-prev{
    display: none;
  }
</style>